module.exports = "/images/model_8ffe73.png";